import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import UserContext from 'src/context/UserContext';
import { useCurrentUserRoles } from 'src/hooks/services/useUser';
import { USER_ROLES } from 'src/utils/constants';

import routes from '../utils/routes';

const PrivateRoute = ({ Component, ...rest }) => {
  const { user } = useContext(UserContext);
  const { data: userRoles, isLoading } = useCurrentUserRoles(user);

  if (!user) {
    // Redirect to log in if there's no user
    return <Navigate replace to={routes.login} />;
  }

  if (isLoading) return null;

  if (userRoles?.includes(USER_ROLES.RESTRICTED)) {
    // Redirect if the user is restricted
    return <Navigate replace to={routes.restricted} />;
  }

  return <Component user={user} {...rest} />;
};

PrivateRoute.propTypes = {
  Component: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
